/**
 * Client-side copy of the flag-key derivation. MUST stay in sync with
 * `flagKey()` in `convex/flags/dismissals.ts` — the key is how a UI flag
 * is matched to its dismissal record.
 */

/** Summarization agents that emit dismissible flags. */
export type FlagAgentKind =
  "assetList" | "securityInterests" | "boardReports" | "atoSro";

/**
 * Deterministic, content-derived key for a single flag. Identical flag
 * content always produces the same key, so a dismissed flag survives an
 * agent re-run and only reappears if its content genuinely changes.
 */
export function flagKey(
  agentKind: FlagAgentKind,
  entryId: string,
  flagType: string,
  detail: string,
): string {
  const normalize = (s: string) => s.trim().toLowerCase().replace(/\s+/g, " ");
  return [agentKind, entryId, normalize(flagType), normalize(detail)].join("");
}
